import { useEffect, useRef } from "react";
import { useGlobalStore } from "../../../globalStore";

export function Dialogs() {
	const dialogRef = useRef<HTMLDialogElement | null>(null);
	const isDev = useGlobalStore((state) => state.isDev);

	const openDialog = async () => {
		const dlg = dialogRef.current;
		if (!dlg) return;

		// @ts-ignore
		await dlg.show({
			title: "Oplux",
			resize: "both",
			size: {
				width: 400,
				height: 900,
			},
		});
	};
	const webviewSrc = isDev
		? `http://localhost:5173`
		: `https://ps-plugin.oplux.ai`;

	useEffect(() => {
		openDialog();
	}, []);

	return (
		<>
			{/* @ts-ignore */}
			<sp-button
				variant="cta"
				className="start-button"
				onClick={() => {
					location.reload();
				}}
			>
				Start Oplux
				{/* @ts-ignore */}
			</sp-button>
			<dialog
				ref={dialogRef}
				style={{
					padding: "0",
					height: "100%",
					width: "100%",
				}}
			>
				<webview
					id="renderer"
					className="webview"
					src={webviewSrc}
					style={{ width: "100%", height: "100%" }}
				/>
			</dialog>
		</>
	);
}
